import React, { useState } from "react";
import Pricing from "./Pricing/index";
import "./organisationProfile.scss";
import Payment from "./payment/index";

function OrganisationProfile({ nextStep, prevStep, change, setChange, setSelectedPlanIndex, setCanGoNext }) {
  const [success, setSuccess] = useState("");
  const [selectPrice, setSelectPrice] = useState("");

  return (
    <>
      <section className="Organisation">
        <div className="container OrganisationContainer">
          {change === "pricing" ? (
            <Pricing
              setChange={setChange}
              setSuccess={setSuccess}
              setSelectPrice={setSelectPrice}
              success={success}
              change={change}
              nextStep={nextStep}
              setSelectedPlanIndex={setSelectedPlanIndex}
              setCanGoNext={setCanGoNext}
            />
          ) : change === "payment" ? (
            <Payment
              selectPrice={selectPrice}
              setChange={setChange}
              setSuccess={setSuccess}
              success={success}
              nextStep={nextStep}
            />
          ) : null}
        </div>
      </section>
    </>
  );
}

export default OrganisationProfile;
